module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAdCAYAAAApQnX+AAAACXBIWXMAAAsSAAALEgHS3X78AAAAfklEQVRYhe3XPQ5AUBhE0SFPp5XYDRqJhVqDUuzAMiQSUaj8hDyJhm4aXzGnnuK2E9RllMOm3gFok9SZqpunA9t6FndVVsWfwZ+6ZsE47AhNVb0ojqU4luJYimMpjqU4luJYimMpjqU4luJYpuPuU+1PrCX+8T9xhX/X5gD9Ba6kGDig9b8DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-yellow-b-2.png
// module id = 256
// module chunks = 0